import { createStore, applyMiddleware, combineReducers } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import dashboardReducer from './reducers/dashboardReducer';
import thunk from 'redux-thunk';

const rootReducer = combineReducers({
    dashboards: dashboardReducer,
});
const store = createStore(
    // dashboardReducer,
    rootReducer,
    composeWithDevTools(applyMiddleware(thunk))
);

export default store;



// WEBPACK FOOTER //
// ./src/redux/store.js